import { Instagram, Phone, Mail } from "lucide-react";
import { useLang, CONTACT, ASSETS } from "../i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[var(--c-bg-2)] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div className="flex items-center gap-4">
            <img src={ASSETS.logo} alt="45 Detailing GVA" className="h-14 w-auto" />
            <div>
              <p className="font-display text-2xl gold-text font-semibold">45 Detailing GVA</p>
              <p className="text-sm text-neutral-500 max-w-xs mt-1">{t.footer.tagline}</p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <a href={CONTACT.phoneHref} aria-label="Phone" className="w-11 h-11 rounded-full gold-border flex items-center justify-center text-[var(--c-gold)] hover:bg-[var(--c-gold)] hover:text-black transition-colors">
              <Phone size={18} />
            </a>
            <a href={`mailto:${CONTACT.email}`} aria-label="Email" className="w-11 h-11 rounded-full gold-border flex items-center justify-center text-[var(--c-gold)] hover:bg-[var(--c-gold)] hover:text-black transition-colors">
              <Mail size={18} />
            </a>
            <a href={CONTACT.instagramHref} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-11 h-11 rounded-full gold-border flex items-center justify-center text-[var(--c-gold)] hover:bg-[var(--c-gold)] hover:text-black transition-colors">
              <Instagram size={18} />
            </a>
          </div>
        </div>

        <div className="mt-10 pt-7 border-t border-white/5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="font-mono text-xs text-neutral-600">
            © {new Date().getFullYear()} 45 Detailing GVA. {t.footer.rights}
          </p>
          <p className="font-mono text-xs text-neutral-600">{CONTACT.instagram} · Genève</p>
        </div>
      </div>
    </footer>
  );
};
